/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  data.js
 */

import {
  CITY_NAME_CHANGED,
  CLEAR_CITY_NAME,
  CLEAR_HOOD_NAME,
  HOOD_NAME_CHANGED,
} from '../../../currentSearch/modules/location/constants'
import {
  CLEAR_HOOD_PRICE_CHART_DATA,
  CLEAR_PRICE_CHART_DATA,
  SET_CITY_PRICE_CHART_DATA,
  SET_HOOD_PRICE_CHART_DATA,
} from '../../constants/detail'
import { cityDataReducerCreator } from '../data/cityDataReducerCreator'
import { hoodDataReducerCreator } from '../data/hoodDataReducerCreator'

export const cityDataReducer = cityDataReducerCreator({
  clearData: CLEAR_PRICE_CHART_DATA,
  clearCityName: CLEAR_CITY_NAME,
  cityNameChanged: CITY_NAME_CHANGED,
  setData: SET_CITY_PRICE_CHART_DATA,
})

export const hoodDataReducer = hoodDataReducerCreator({
  clearData: CLEAR_PRICE_CHART_DATA,
  clearHoodData: CLEAR_HOOD_PRICE_CHART_DATA,
  clearCityName: CLEAR_CITY_NAME,
  clearHoodName: CLEAR_HOOD_NAME,
  hoodNameChanged: HOOD_NAME_CHANGED,
  setData: SET_HOOD_PRICE_CHART_DATA,
})
